export const applyVerticalColumns = ({ columnInstance, setGridHasVerticalColumns }) => {
  const columnIsVertical = columnInstance.some(
    (column) => column.field?.includes('week') && column.field?.includes('-vertical')
  );

  setGridHasVerticalColumns(columnIsVertical);

  if (!columnIsVertical) return columnInstance;

  return columnInstance.map((column) => {
    const existingClass = column.headerClass || '';
    if (column.field?.includes('week') && column.field?.includes('-vertical')) {
      column['headerClass'] = `${existingClass} ag-header-week-vertical`.trim();
    } else {
      column['headerClass'] = `${existingClass} ag-header-none-vertical`.trim();
    }

    return column;
  });
}